import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInfo = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
        <path
            fill="#0B5FD5"
            fillRule="evenodd"
            d="M15.429 18A2.574 2.574 0 0 0 18 15.429V2.57A2.574 2.574 0 0 0 15.429 0H2.57A2.574 2.574 0 0 0 0 2.571V15.43A2.574 2.574 0 0 0 2.571 18zM9.025 6.5a.875.875 0 1 1 0-1.75.875.875 0 0 1 0 1.75m0 7a.874.874 0 0 1-.875-.875V8.25a.874.874 0 1 1 1.75 0v4.375a.875.875 0 0 1-.875.875"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgInfo;
